import React, { FC, useEffect, useState } from 'react';
import { TouchableOpacity } from 'react-native';

export type LinkProps = {
  /**
   * The accessibility role of this link, can be a button or a link
   */
  accessibilityRole: 'button' | 'link';
  /**
   *  The content displayed in the link
   */
  children: any;

  /**
   *  Whether the link is disabled
   */
  disabled?: any;

  /**
   * onHover handler
   */
  onHover?: (e: any) => void;

  /**
   * onPress click handler
   */
  onPress: (e: any) => void;

  /**
   * Optional Url parameter
   */
  url?: any;
};

// TODO: ADD a url prop can add it later
export const Link: FC<LinkProps> = ({
  accessibilityRole,
  children: content,
  disabled,
  onHover,
  onPress,
  url,
}) => {
  const [isHovering, setHoverState] = useState(false);

  const linkOnPress = (e) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    if (!url) {
      onPress && onPress(e);
      console.log('Clicked a link; navigate to new location');
    }
  };

  const linkOnMouseEnter = () => {
    const hovered = true;
    setHoverState(hovered);
  };
  const linkOnMouseLeave = () => {
    const hovered = false;
    setHoverState(hovered);
  };
  useEffect(() => {
    onHover && onHover(isHovering);
  }, [isHovering]);

  return (
    <TouchableOpacity
      accessibilityRole={accessibilityRole}
      disabled={disabled}
      onMouseEnter={linkOnMouseEnter}
      onMouseLeave={linkOnMouseLeave}
      onPress={linkOnPress}
    >
      {content}
    </TouchableOpacity>
  );
};

export default Link;
